export default __webpack_public_path__ + "static/media/Creative-IAMA.b3335f0e.png";